export default {
    api: {
        aboutTo:
            'You are about to revoke access from <0>{{apiName}}</0>. They will no longer have access to <1>{{partnerName}}</1> data.',
        submit: 'Revoke Access',
        title: 'Revoke {{apiName}}',
    },
    employee: {
        afterRevoking: 'After revoking <0>{{employeeName}}</0>:',
        afterRevokingDocumentsAndHistory:
            'Documents and history events created by the Member will be preserved.',
        afterRevokingNoMoreAccess:
            'The Member will no longer have access to the data of the Company.',
        details: 'Team Member details:',
        detailsCompanyPartner: 'Company: <0>{{partnerName}}</0>',
        detailsCompanyPartnerAndAccount:
            'Company: <0>{{partnerName}}</0> <1>{{accountName}}</1>',
        detailsName: 'Name: <0>{{employeeName}}</0>',
        revoke: 'Revoke Access',
        revokingAutomaticallyDiscards:
            'Note: Revoking will automatically discard <0>{{scheduledSendingOrderCount}}</0> Scheduled Send(s) created by <1>{{employeeName}}</1>.',
        title: 'Revoke Team Member',
    },
};
